<template>
    <div class="border rounded-3 p-3 logo-wrapper" id="logo-light-info">

        <div class="left">
            <!-- Logo Dark-->
            <div class="logo-preview">
                <div>
                    <label class="form-label fw-bold mb-0 pb-2">
                        Logo For Use On Light Background
                    </label>
                </div>
                <div>
                    <div v-if="!isLoadingTemporaryLink && logoImgSrc" class="logo-container">
                        <img class="d-block" :key="`whitelabel-logo-${updateKey}`" :src="logoImgSrc" width="200"
                            alt="Logo" />
                    </div>
                    <div v-if="!isLoadingTemporaryLink && !logoImgSrc">
                        No logo uploaded.
                    </div>
                </div>
            </div>
            <!-- / Logo Dark -->
        </div>

        <div class="right">
            <input type="file" class="file-input" ref="fileInput" accept="image/*" @change="onFilePicked" />

            <button type="button" class="btn btn-primary btn-sm" @click.prevent="attemptChangeLogo">
                Click To Upload
            </button>
        </div>

    </div>
</template>
<script>
import { mapActions } from 'vuex';
import temporaryUrls from '../../../../api/temporary-urls';
import Images from '../../../../mixins/Images';
import axios from 'axios';
import Forms from '../../../../mixins/Forms';

import { useToast } from 'vue-toastification';

const toast = useToast();

export default {
    props: ['myFirm'],
    data() {
        return {
            temporaryLink: null,
            updateKey: 1,
            isLoadingTemporaryLink: false
        }
    },
    created() {
        this.loadTemporaryLink();
    },
    mixins: [Images, Forms],
    components: {},
    computed: {
        logoImgSrc() {
            if (this.temporaryLink) {
                return this.temporaryLink.url;
            }
            return null;
        }
    },
    methods: {
        reloadMyFirm() {
            this.$emit('reload');
        },

        loadTemporaryLink() {
            let vm = this;
            vm.isLoadingTemporaryLink = true;
            temporaryUrls.getPanelConfigurationLogoTemporaryUrl(this.myFirm.id).then(r => {
                vm.isLoadingTemporaryLink = false;
                vm.temporaryLink = r.data;
                vm.updateKey += 1;
            }).catch(e => {
                console.log(e);
                vm.isLoadingTemporaryLink = false;
                vm.temporaryLink = null;
            });
        },

        attemptChangeLogo() {
            this.$refs.fileInput.click();
        },

        onFilePicked(e) {
            let vm = this;
            const file = e.target.files[0];

            let formData = new FormData();
            formData.append('logo', file);

            axios.post(window.API_BASE + '/my-firm/logo', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(r => {
                toast.success('Logo updated successfully');
                vm.loadTemporaryLink();
            }).catch(e => {
                vm.setAndNotifyErrors(e, 'Error updating logo');
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.file-input {
    display: none;
}

.logo-container {
    // border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    margin-top: 5px;
    // background-color: rgb(31, 27, 45);
    display: inline-block;
}

.logo-wrapper {
    display: flex;
    justify-content: space-between;

    .left {
        flex-grow: 1;
    }

    .right {
        flex-shrink: 1;
        display: flex;
        align-items: center;
    }
}
</style>